import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'kv-table',
    template: `<table class="table">
    <thead>
        <tr>
            <th colspan="2">
                <h3 translate>{{title}}</h3>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let k of keys">
            <th scope="row">{{k}}</th>
            <td>{{config[k]}}</td>
        </tr>
    </tbody>
</table>`
})
export class KeyValueTableComponent implements OnInit, OnChanges {

    @Input() title: string = '';
    @Input() config: any = {};

    protected keys: any = [];

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        this.keys = Object.keys(this.config);
    }
    
    ngOnInit() { }
}
